import React,{useState} from "react";
import "./../Wrapper/Wrapper.css";



export default function Navbar(props) {

  function toggleHover()
  {
   
    setHover(!hover);
  
  }

  const [customBackgroundColor,setCustomBackgroundColor]=useState(props.custom_design.colors[0].color);
  const [hover,setHover]=useState(false);

  return (
    <nav style={{backgroundColor:'#'+customBackgroundColor}}>
      <div className="nav-wrapper" >
        <ul >
          <li onMouseEnter={toggleHover} onMouseLeave={toggleHover} style={{backgroundColor:'#'+customBackgroundColor}}>
            <a  href="/" style={{color:'#'+props.custom_design.colors[3].color}}>
                ホーム<i className="material-icons left">home</i> 
            </a>
          </li>
          <li onMouseEnter={toggleHover} onMouseLeave={toggleHover} style={{backgroundColor:'#'+customBackgroundColor}}>
            <a  style={{color:'#'+props.custom_design.colors[3].color}} href="/company">会社概要</a>
          </li>
          <li onMouseEnter={toggleHover} onMouseLeave={toggleHover} style={{backgroundColor:'#'+customBackgroundColor}}>
            <a  style={{color:'#'+props.custom_design.colors[3].color}} href="/page1">翻訳サービス</a>
          </li>
          <li onMouseEnter={toggleHover} onMouseLeave={toggleHover} style={{backgroundColor:'#'+customBackgroundColor}}>
            <a  style={{color:'#'+props.custom_design.colors[3].color}} href="/page3">DTP サービス</a>
          </li>
          <li onMouseEnter={toggleHover} onMouseLeave={toggleHover} style={{backgroundColor:'#'+customBackgroundColor}}>
            <a  style={{color:'#'+props.custom_design.colors[3].color}} href="/contactus"> お問い合わせ</a>
          </li>
        </ul>
      </div>
    </nav>
  );
}
